import { makeStyles } from "@fluentui/react-components";

const useButtonStyles = makeStyles({
  root: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  contentWrapper: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
  },
});

export default useButtonStyles;
